// extracted by mini-css-extract-plugin
module.exports = {"bank":"_7a3fb80146--bank--Jszpi","img":"_7a3fb80146--img--ktKbK"};